import React from 'react';
import { MDBRow, MDBBtn, MDBIcon } from 'mdbreact';

// A paleta vive em styles/cores-sobrias.css (#184). Referenciar a variável, e
// não copiar o hex, evita a paleta mista que a auditoria de 05/08 encontrou.
const COR_DESTRUTIVA = 'var(--sig-destrutiva)';
const COR_CONSTRUTIVA = 'var(--sig-construtiva)';

// Listagem de lotações da tela Gerência × Lotação (#174/#205).
//
// A listagem mostra ATIVAS E INATIVAS de propósito: o select de ala do modal
// omite os pares que a gerência+escala já tem (o par continua ocupado mesmo
// inativo), então esconder as inativas deixaria "Reativar" sem onde clicar.
//
// O cabeçalho cinza (Gerência/Escala/Ala/Pessoas) fica no index.js, fora do
// ternário de loading/erro — ele precisa aparecer nos três estados, e este
// componente só é renderizado no ramo "lista pronta" (fix round 1, #205).
export default function TabelaLotacoes({
  lotacoes,
  bloqueios,
  onAlternarAtivo,
  gerenciaSelecionada,
}) {
  return (
    <>
      {lotacoes.length === 0 ? (
        <MDBRow
          style={{ borderRadius: '5px' }}
          className="p-3 mr-1 ml-1 mt-1 mr-md-3 ml-md-3 bg-white justify-content-center"
        >
          <span className="grey-text">
            {gerenciaSelecionada
              ? 'Nenhuma lotação vinculada a esta gerência.'
              : 'Selecione uma gerência para ver as lotações.'}
          </span>
        </MDBRow>
      ) : (
        lotacoes.map(l => (
          <MDBRow
            key={l.id}
            between
            style={{ borderRadius: '5px' }}
            className="p-2 mr-1 ml-1 mt-1 mr-md-3 ml-md-3 align-items-center bg-white"
          >
            <div className="col-12 col-md-3 d-flex justify-content-between">
              <span className="d-sm-inline d-md-none mr-3">Gerência:</span>
              {l.gerencia.nome}
            </div>
            <div className="col-12 col-md-2 d-flex justify-content-between">
              <span className="d-sm-inline d-md-none mr-3">Escala:</span>
              {l.escala.nome}
            </div>
            <div className="col-12 col-md-3 d-flex justify-content-between">
              <span className="d-sm-inline d-md-none mr-3">Ala:</span>
              {l.ala.nome}
            </div>
            {/* ativos / total: o total inclui quem já saiu, e é o que separa
                "lotação esvaziada" de "lotação que nunca foi usada" */}
            <div className="col-12 col-md-2 d-flex justify-content-between">
              <span className="d-sm-inline d-md-none mr-3">Pessoas:</span>
              <span>
                {Number(l.qtd_usuarios_ativos || 0)}
                <span className="grey-text">
                  {` / ${Number(l.qtd_usuarios_total || 0)}`}
                </span>
              </span>
            </div>
            <div className="col-12 col-md-2 d-flex justify-content-center justify-content-md-end mt-2 mt-md-0">
              <MDBBtn
                size="sm"
                color="white"
                className="m-0"
                style={{
                  color: l.ativo ? COR_DESTRUTIVA : COR_CONSTRUTIVA,
                  border: `1px solid ${
                    l.ativo ? COR_DESTRUTIVA : COR_CONSTRUTIVA
                  }`,
                  boxShadow: 'none',
                }}
                onClick={() => onAlternarAtivo(l)}
              >
                <MDBIcon
                  far
                  icon={l.ativo ? 'thumbs-down' : 'thumbs-up'}
                  className="mr-2"
                />
                {l.ativo ? 'Inativar' : 'Reativar'}
              </MDBBtn>
            </div>

            {bloqueios[l.id] && (
              <div className="col-12 mt-2" style={{ color: COR_DESTRUTIVA }}>
                <MDBIcon icon="exclamation-triangle" className="mr-2" />
                {`${bloqueios[l.id]} pessoa(s) ainda estão nesta lotação — mova-as antes.`}
              </div>
            )}
          </MDBRow>
        ))
      )}
    </>
  );
}
